import React, { Component } from 'react';
import AcceleratedReader from "react/views/readingLevel/acceleratedReader/AcceleratedReader";
import { getPrimaryIsbn } from 'data/TitleInfoSelector';
import { getJsonData, getProfileData, getCustLinks } from "data/DataStore";
import { attachFunctionToCallback } from "utility";
import { performJsonpGetRequest } from "lib/HttpRequest";
import { generateAcceleratedReaderSearchUrl } from "./arSearchUrlBuilder";
import { getOtsAvailabilityForResults } from "data/OtsRequests";
import { projectCarouselResults } from 'data/CarouselItemSelector';

const arSearchCallbackName = "arSearchCallback";

class  AcceleratedReaderContainer extends Component {
	constructor(props) {
		super(props);
		this.arData = this.props.cardModel;

		this.currentIsbn = getPrimaryIsbn(getJsonData());
		this.state = {
			isLoading: false,
			arResults: null,
		};

		this.arSearchCallback = this.arSearchCallback.bind(this);
		this.handleSearch = this.handleSearch.bind(this);

		attachFunctionToCallback(this.arSearchCallback, arSearchCallbackName);
	}

	arSearchCallback(data) {
		getOtsAvailabilityForResults(data);
		this.setState({
			isLoading: false,
			arResults: data
		});
	}

	handleSearch(bookLevel, interestLevel) {
		this.setState({ isLoading: true });
		let profileData = getProfileData();
		let custLinks = getCustLinks();
		let arSearchUrl = generateAcceleratedReaderSearchUrl(profileData,this.currentIsbn, bookLevel, interestLevel, custLinks);
		performJsonpGetRequest(arSearchUrl, arSearchCallbackName);
	}

	render() {
		return (
			<AcceleratedReader
				bookLevel={this.arData.bookLevel}
				interestLevel={this.arData.interestLevel}
				loggingId={this.currentIsbn}
				handleSearch={this.handleSearch}
				isLoading={this.state.isLoading}
				novelistLink=""
				resultData={projectCarouselResults(this.state.arResults)}
			/>
		);
	}
}

export default AcceleratedReaderContainer;



// WEBPACK FOOTER //
// ./src/react/containers/acceleratedReader/AcceleratedReaderContainer.jsx